"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var vizportal_webclient_api_1 = require("@tableau/vizportal-webclient-api");
var GetDatasourcesWithConnectabilityDetailsMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/GetDatasourcesWithConnectabilityDetailsMethod");
var IFilterClause_1 = require("@tableau/vizportal-webclient-api/lib/api/types/IFilterClause");
var typestyle_1 = require("typestyle");
var ConnectToDatabasesDescriptionQueryGql_1 = require("../queries/ConnectToDatabasesDescriptionQueryGql");
var ConnectToTablesDescriptionQueryGql_1 = require("../queries/ConnectToTablesDescriptionQueryGql");
var ConnectToDialogStyles_1 = require("../style/ConnectToDialogStyles");
var Logger_1 = require("../utils/Logger");
var ConnectToButton_1 = require("./ConnectToButton");
var ConnectToDialogFunctions_1 = require("./ConnectToDialogFunctions");
var ConnectToRowDescription_1 = require("./ConnectToRowDescription");
var ConnectToRowDisabledWarning_1 = require("./ConnectToRowDisabledWarning");
var ConnectToDialogBottomPanel = /** @class */ (function (_super) {
    __extends(ConnectToDialogBottomPanel, _super);
    function ConnectToDialogBottomPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.localIsMounted = false;
        _this.currentUpdateId = 0;
        _this.getDescriptionAndRowEnabledInfoForSelectedRow = function (selectedKeys) { return __awaiter(_this, void 0, void 0, function () {
            var myUpdateId, selectedRowId, _a, data, selectedDatabase, connectionType, selectedRowEnabled, getDatasources, slice, result, datasource, description, selectedRowEnabled, hasConnectPermission, isSupported, data, selectedTable, connectionType, selectedRowEnabled;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        myUpdateId = ++this.currentUpdateId;
                        // The function will only be called when selectedKeys.length > 0.
                        // For single selection, there should be one and only one value in selectedKeys.
                        if (Object.keys(selectedKeys).length !== 1) {
                            return [2 /*return*/];
                        }
                        selectedRowId = Object.keys(selectedKeys)[0];
                        _a = this.props.selectedDataType;
                        switch (_a) {
                            case 'Databases': return [3 /*break*/, 1];
                            case 'Datasources': return [3 /*break*/, 3];
                            case 'Tables': return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, this.props.client.query({
                            query: ConnectToDatabasesDescriptionQueryGql_1.ConnectToDatabasesDescriptionQueryGql,
                            variables: { databaseId: selectedRowId }
                        })];
                    case 2:
                        data = (_b.sent()).data;
                        if (data == null
                            || data.databasesConnection == null
                            || data.databasesConnection.nodes == null
                            || data.databasesConnection.nodes.length !== 1) {
                            return [2 /*return*/];
                        }
                        selectedDatabase = data.databasesConnection.nodes[0];
                        if (myUpdateId === this.currentUpdateId && selectedDatabase != null) {
                            connectionType = selectedDatabase ? selectedDatabase.connectionType : null;
                            selectedRowEnabled = ConnectToDialogFunctions_1.isRowEnabledForTableOrDatabase(connectionType, this.props.allowedClasses);
                            if (this.localIsMounted) {
                                this.setState({ rowDescription: selectedDatabase.description, selectedRowEnabled: selectedRowEnabled });
                            }
                        }
                        return [2 /*return*/];
                    case 3:
                        getDatasources = this.props.vizPortalWebClientRequester.createSender(GetDatasourcesWithConnectabilityDetailsMethod_1.GetDatasourcesWithConnectabilityDetailsMethod);
                        return [4 /*yield*/, getDatasources(new vizportal_webclient_api_1.GetItemsParams({
                                startIndex: 0,
                                maxItems: 1
                            }, {
                                clauses: [vizportal_webclient_api_1.Filter.stringFieldEq('repositoryUrl', selectedRowId), vizportal_webclient_api_1.Filter.fieldEq(IFilterClause_1.FilterFieldNames.isPublished, true)],
                                operator: IFilterClause_1.FilterOps.and
                            }))];
                    case 4:
                        slice = _b.sent();
                        if (myUpdateId === this.currentUpdateId
                            && !vizportal_webclient_api_1.WebClientResponseHelper.isErrorResponse(slice) && ConnectToDialogFunctions_1.isIGetDatasourcesResult(slice.response.result)) {
                            result = slice.response.result;
                            if (result.datasources == null || result.datasources.length !== 1) {
                                return [2 /*return*/];
                            }
                            datasource = result.datasources[0];
                            description = datasource.description;
                            selectedRowEnabled = ConnectToDialogFunctions_1.isRowEnabledForDatasource(datasource);
                            hasConnectPermission = this.doesDatasourceHaveConnectPermission(datasource);
                            isSupported = this.isDatasourceSupported(datasource);
                            this.setState({
                                rowDescription: description,
                                selectedRowEnabled: selectedRowEnabled,
                                doesDatasourceHaveConnectPermission: hasConnectPermission,
                                isDatasourceSupported: isSupported
                            });
                        }
                        return [2 /*return*/];
                    case 5: return [4 /*yield*/, this.props.client.query({
                            query: ConnectToTablesDescriptionQueryGql_1.ConnectToTablesDescriptionQueryGql,
                            variables: { tableId: selectedRowId }
                        })];
                    case 6:
                        data = (_b.sent()).data;
                        if (data == null
                            || data.databaseTablesConnection == null
                            || data.databaseTablesConnection.nodes == null
                            || data.databaseTablesConnection.nodes.length !== 1) {
                            return [2 /*return*/];
                        }
                        selectedTable = data.databaseTablesConnection.nodes[0];
                        if (myUpdateId === this.currentUpdateId && selectedTable != null) {
                            connectionType = selectedTable.database ? selectedTable.database.connectionType : null;
                            selectedRowEnabled = ConnectToDialogFunctions_1.isRowEnabledForTableOrDatabase(connectionType, this.props.allowedClasses);
                            this.setState({ rowDescription: selectedTable.description, selectedRowEnabled: selectedRowEnabled });
                        }
                        return [2 /*return*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            selectedRowEnabled: true,
            rowDescription: '',
        };
        return _this;
    }
    ConnectToDialogBottomPanel.prototype.isRowSelected = function () {
        return Object.keys(this.props.selectedRowIds).length > 0;
    };
    ConnectToDialogBottomPanel.prototype.componentDidUpdate = function () {
        var _this = this;
        this.localIsMounted = true;
        var rowSelected = this.isRowSelected();
        if (rowSelected) {
            this.getDescriptionAndRowEnabledInfoForSelectedRow(this.props.selectedRowIds)
                .catch(function (error) {
                Logger_1.Logger.error(error);
                if (_this.localIsMounted) {
                    _this.setState({ rowDescription: '', selectedRowEnabled: true });
                }
            });
        }
        else {
            if (this.localIsMounted) {
                this.setState({ rowDescription: '', selectedRowEnabled: true });
            }
        }
    };
    ConnectToDialogBottomPanel.prototype.componentWillUnmount = function () {
        this.localIsMounted = false;
    };
    ConnectToDialogBottomPanel.prototype.doesDatasourceHaveConnectPermission = function (datasource) {
        return datasource.connectabilityDetails != null
            && !!datasource.connectabilityDetails.hasConnectPermission;
    };
    ConnectToDialogBottomPanel.prototype.isDatasourceSupported = function (datasource) {
        return datasource.connectabilityDetails != null
            && !!datasource.connectabilityDetails.isConnectableDBClass
            && !datasource.isHierarchical;
    };
    ConnectToDialogBottomPanel.prototype.render = function () {
        return (React.createElement("div", null,
            this.isRowSelected() && this.state.rowDescription ?
                React.createElement(ConnectToRowDescription_1.ConnectToRowDescription, { rowDescription: this.state.rowDescription, testId: 'connect-to-row-description' }) :
                null,
            this.isRowSelected() && !this.state.selectedRowEnabled ?
                React.createElement(ConnectToRowDisabledWarning_1.ConnectToRowDisabledWarning, { doesDatasourceHaveConnectPermission: this.state.doesDatasourceHaveConnectPermission, isDatasourceSupported: this.state.isDatasourceSupported }) :
                null,
            React.createElement("div", { className: typestyle_1.classes(ConnectToDialogStyles_1.ConnectToButtonContainer) },
                React.createElement(ConnectToButton_1.ConnectToButton, { handleButtonClick: this.props.handleButtonClick, disableButton: !this.isRowSelected() || !this.state.selectedRowEnabled }))));
    };
    return ConnectToDialogBottomPanel;
}(React.PureComponent));
exports.ConnectToDialogBottomPanel = ConnectToDialogBottomPanel;
//# sourceMappingURL=ConnectToDialogBottomPanel.js.map